"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * expert-queue-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var SessionEvent;
(function (SessionEvent) {
    SessionEvent["AttributeChanged"] = "attributeChanged";
    SessionEvent["Cancelled"] = "cancelled";
    SessionEvent["Pending"] = "pending";
    SessionEvent["Assigned"] = "assigned";
    SessionEvent["Unassigned"] = "unassigned";
    SessionEvent["Resolved"] = "resolved";
    SessionEvent["AddAnotherExpert"] = "addAnotherExpert";
    SessionEvent["Created"] = "created";
    SessionEvent["Republish"] = "republish";
    SessionEvent["Closed"] = "closed";
    SessionEvent["RepublishForExperts"] = "republishForExperts";
})(SessionEvent = exports.SessionEvent || (exports.SessionEvent = {}));
function SessionEventFromJSON(json) {
    return SessionEventFromJSONTyped(json, false);
}
exports.SessionEventFromJSON = SessionEventFromJSON;
function SessionEventFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SessionEventFromJSONTyped = SessionEventFromJSONTyped;
function SessionEventToJSON(value) {
    return value;
}
exports.SessionEventToJSON = SessionEventToJSON;
